import React from 'react';

import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';
import clsx from 'clsx';

const strings = createStrings({
  ja: {
    required: '必須',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  requiredTag: {
    ...common.smallerText,
    ...common.textError,
    padding: '0 8px',
    display: 'inline-block',
    border: `1px solid ${theme.palette.error.main}`,
    borderRadius: 8,
    whiteSpace: 'nowrap',
  },
}));

export interface RequiredTagProps {
  className?: string;
  style?: React.CSSProperties;
}

export const RequiredTag: React.FC<RequiredTagProps> = (props) => {
  const { className, style } = props;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <span className={clsx(classes.requiredTag, className)} style={style}>
      {strings.required}
    </span>
  );
};
